import { Grid, Button, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { QuestionInterfaceProps } from "../types";
import CloseIcon from '@mui/icons-material/Close';
import { REFEREDUM_VALUE } from "./types";
import { useCallback } from "react";
import { yesnoValidate } from "./yes-no-validate";
import { IQuestionState } from "../../domain/ballot-state";
import { YES_NO } from "./yes-no-typedef";


export const YesNoQuestion = ({ question, setQuestionState, questionState }: QuestionInterfaceProps) => {
    const value = YES_NO.normalize(questionState);

    const setQuestionVote = useCallback(
        (value: React.SetStateAction<any>) => {
            setQuestionState((response: IQuestionState) => {
                const _value = typeof value === "function" ? value(response.value) : value;

                const validation = yesnoValidate(question, _value);

                return {
                    question_id: question.id,
                    response_type: question.response_type,
                    valid: validation.valid,
                    invalid_reasons: validation.reasons,
                    data_version: "1.0.0",
                    dirty: true,
                    value: _value
                };
            });
        },
        [setQuestionState, question]
    );

    const handleYes = () => {
        setQuestionVote(REFEREDUM_VALUE.YES);
    };
    const handleNo = () => {
        setQuestionVote(REFEREDUM_VALUE.NO);
    };
    return (
        <Grid container spacing={3}>
            <Grid item sm={6} xs={12} p={1}>
                <LargeCheckButton
                    label="YES"
                    checked={value === REFEREDUM_VALUE.YES}
                    onClick={handleYes}
                    icon={<CheckIcon sx={{ fontSize: 35, color: "#444" }} />}
                />
            </Grid>
            <Grid item sm={6} xs={12} p={1}>
                <LargeCheckButton
                    label="NO"
                    checked={value === REFEREDUM_VALUE.NO}
                    onClick={handleNo}
                    icon={<CloseIcon sx={{ fontSize: 35, color: "#444" }} />}
                />
            </Grid>
        </Grid>
    );
};
interface LargeCheckButtonProps {
    onClick: () => void;
    label: string;
    checked: boolean;
    icon: JSX.Element;
}
const LargeCheckButton = ({
    onClick,
    label,
    checked,
    icon
}: LargeCheckButtonProps) => {
    return (
        <Button
            variant={"outlined"}
            onClick={onClick}
            fullWidth
            color={"interface" as any}
            sx={{ px: 3, py: 1.5, fontSize: 25, display: 'flex', justifyContent: 'space-between' }}
        >
            {label}
            <Box
                sx={{
                    border: "#777 solid  2px ",
                    height: 30,
                    width: 30,
                    marginRight: 2,
                    borderRadius: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    textDecoration: "none",
                }}
            >
                {checked ? (
                    icon
                ) : undefined}
            </Box>

        </Button>
    );
};
